module.exports = __webpack_public_path__ + "static/img/digital_logo.96734f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/digital_logo.png
// module id = 1eWy
// module chunks = 0